var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.aiRules.length>0)?[_vm._l((_vm.aiRules),function(ele,i){return [_c('ai-readable-chips',{key:i,attrs:{"filterObject":ele,"conditionText":_vm.conditionText ? 'AND' : 'OR',"filterIndex":i,"aiRules":_vm.aiRules}})]})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }